import Vue from 'vue'

const state = {
  namespaced: true,
  state: {
    entities: [],
    openedEntity: {},
    pageChunkSize: 12,
    searchByVendorOption: false,
    lastSelectedVendor: null,
    lastSelectedDivision: null,
    lastSelectedDestination: null,
    lastSelectedRate: null,
    lastSelectedTestType: null,
    lastSelectedCallerId: null,
    lastSelectedPhoneNumbers: null,
    callTestsStatusesObject: {
      0: { label: '', class: 'voip-call-test-status'},
      1: { label: 'Awaiting Action', class: 'voip-call-test-status awaiting-action'},
      2: { label: 'Working', class: 'voip-call-test-status working'},
      3: { label: 'FAS', class: 'voip-call-test-status fas'},
      4: { label: 'Unconnected', class: 'voip-call-test-status unconnected'},
      5: { label: 'Requires Test', class: 'voip-call-test-status requires-test'},
      6: { label: 'Pending', class: 'voip-call-test-status pending'},
    },
    callTestsStatusesMrtObject: {
      0: { label: '', class: 'voip-call-test-status'},
      1: { label: 'Awaiting Action', class: 'voip-call-test-status awaiting-action'},
      2: { label: 'Working', class: 'voip-call-test-status working'},
      3: { label: 'FAS', class: 'voip-call-test-status fas'},
      4: { label: 'Unconnected', class: 'voip-call-test-status unconnected'},
    },
    callTestStatuses: [
      {
        value: 2,
        label: "Working",
      },
      {
        value: 6,
        label: "Pending",
      },
      {
        value: 3,
        label: "FAS",
      },
      {
        value: 4,
        label: "Unconnected",
      },
      {
        value: 5,
        label: "Requires Test"
      }
    ],
    callTestStatusesMrt: [
      {
        value: 2,
        label: "Working",
      },
      {
        value: 3,
        label: "FAS",
      },
      {
        value: 4,
        label: "Unconnected",
      },
    ]
  },
  actions: {
    setState ({ commit }, params) {
      commit('SET_STATE', params)
    },
    setEntities ({ commit }, entities) {
      commit('SET_ENTITIES', entities)
    },
    setOpenedEntity ({ commit }, entity) {
      commit('SET_OPENED_ENTITY', entity)
    },
    addEntity ({ commit }, entity) {
      commit('ADD_ENTITY', entity)
    },
    removeEntity ({ commit }, entityId) {
      commit('REMOVE_ENTITY', entityId)
    },
  },
  mutations: {
    SET_STATE (state, params) {
            state[params.key] = params.value
        },
    ADD_ENTITY (state, entity) {
      Vue.set(state.entities, entity.id, entity)
    },
    REMOVE_ENTITY (state, entityId) {
      Vue.delete(state.entities, entityId);
    },
    SET_ENTITIES (state, entities) {
      state.entities = entities
    },
    SET_OPENED_ENTITY (state, entity) {
      state.openedEntity = entity
    }
  },
  getters: {}
};

export default state
